import { TemaCard } from 'src/data/models/TemaCardModel';

export const spanishCultureCards: TemaCard[] = [
    // 🏛 Spanish Traditions
    new TemaCard(
        'culture1',
        'Spanish Culture',
        'word',
        'siesta',
        'afternoon nap',
        'A traditional nap taken after lunch, typically from 2 PM to 5 PM. Not all Spaniards practice it anymore, but it’s still a cultural symbol.',
        [
            { spanish: 'siesta', english: 'afternoon nap' },
        ]
    ),

    new TemaCard(
        'culture2',
        'Spanish Culture',
        'phrase',
        '¡Salud! / ¡Chin chin!',
        'Cheers!',
        'A common toast when drinking. The phrase “¡Salud!” is often used in Spain during celebrations, while “¡Chin chin!” is more common in Latin America.',
        [
            { spanish: '¡Salud!', english: 'Cheers!' },
            { spanish: '¡Chin chin!', english: 'Cheers!' },
        ]
    ),

    new TemaCard(
        'culture3',
        'Spanish Culture',
        'sentence',
        'La comida es muy importante en la cultura española.',
        'Food is very important in Spanish culture.',
        'Food and meals are central to social life in Spain. Dinner is usually late, and it’s an occasion to gather family and friends.',
    ),

    // 🎉 Festivals
    new TemaCard(
        'culture4',
        'Spanish Culture',
        'phrase',
        '¡Feliz Navidad! / ¡Felices Fiestas!',
        'Merry Christmas! / Happy Holidays!',
        'Christmas and New Year celebrations in Spain are very festive and include family gatherings, food, music, and fireworks.',
        [
            { spanish: '¡Feliz Navidad!', english: 'Merry Christmas!' },
            { spanish: '¡Felices Fiestas!', english: 'Happy Holidays!' },
        ]
    ),

    new TemaCard(
        'culture5',
        'Spanish Culture',
        'idiom',
        'Año nuevo, vida nueva',
        'New year, new life',
        'A popular saying that marks the start of a new year, encouraging people to embrace change and new beginnings.',
    ),

    new TemaCard(
        'culture6',
        'Spanish Culture',
        'sentence',
        'La fiesta de La Tomatina es una de las más famosas de España.',
        'The La Tomatina festival is one of the most famous in Spain.',
        'Held annually in Buñol, Valencia, it’s a fun and messy festival where thousands of people throw tomatoes at each other.',
    ),

    // 🕺 Spanish Dance and Music
    new TemaCard(
        'culture7',
        'Spanish Culture',
        'word',
        'flamenco',
        'flamenco (dance and music)',
        'A traditional Spanish art form that includes singing, guitar playing, dance, and handclaps. Originating in Andalusia, it’s a symbol of Spanish culture.',
        [
            { spanish: 'flamenco', english: 'flamenco (dance and music)' },
        ]
    ),

    new TemaCard(
        'culture8',
        'Spanish Culture',
        'idiom',
        'No hay mal que por bien no venga',
        'Every cloud has a silver lining.',
        'An optimistic saying meaning that every bad situation will eventually lead to something good.',
    ),

    // 🧑‍🤝‍🧑 Social Norms and Values
    new TemaCard(
        'culture9',
        'Spanish Culture',
        'phrase',
        '¡Vale! / ¡Venga!',
        'Okay! / Come on!',
        'Common informal phrases used to agree with someone or encourage someone to do something.',
        [
            { spanish: '¡Vale!', english: 'Okay!' },
            { spanish: '¡Venga!', english: 'Come on!' },
        ]
    ),

    new TemaCard(
        'culture10',
        'Spanish Culture',
        'sentence',
        'En España, se da mucha importancia al tiempo con la familia.',
        'In Spain, a lot of importance is placed on family time.',
        'Family is a central pillar in Spanish culture. Meals, holidays, and celebrations are often family-oriented.',
    ),

    new TemaCard(
        'culture11',
        'Spanish Culture',
        'sentence',
        'Es común hacer la sobremesa después de una comida.',
        'It’s common to linger at the table after a meal.',
        'After meals, Spaniards tend to stay at the table talking and drinking coffee or tea. This is known as "sobremesa".',
    ),

    // 🌎 Spanish Influence Globally
    new TemaCard(
        'culture12',
        'Spanish Culture',
        'sentence',
        'El español es el segundo idioma más hablado del mundo.',
        'Spanish is the second most spoken language in the world.',
        'Spanish is spoken by over 460 million people across the globe, making it an important global language.',
    ),

    new TemaCard(
        'culture13',
        'Spanish Culture',
        'word',
        'tapear',
        'to go for tapas',
        'The act of going out and enjoying small dishes called "tapas". It’s a social activity that usually happens in the evening.',
        [
            { spanish: 'tapear', english: 'to go for tapas' },
        ]
    ),

];
